import { Controller } from "@hotwired/stimulus"

// Tracks which TOC entry corresponds to the heading currently in view
// and toggles `toc-link-active` accordingly. Idempotent on reconnect.
export default class extends Controller {
  static targets = ["link"]

  connect() {
    this.observer = new IntersectionObserver(this.onIntersect.bind(this), {
      rootMargin: "0% 0% -70% 0%",
      threshold: 0
    })

    this.linkTargets.forEach(link => {
      const id = (link.getAttribute("href") || "").replace(/^#/, "")
      const heading = id && document.getElementById(id)
      if (heading) this.observer.observe(heading)
    })
  }

  disconnect() {
    if (this.observer) this.observer.disconnect()
  }

  onIntersect(entries) {
    entries
      .filter(e => e.isIntersecting)
      .forEach(entry => {
        const id = entry.target.id
        this.linkTargets.forEach(link => {
          const matches = (link.getAttribute("href") || "") === `#${id}`
          link.classList.toggle("toc-link-active", matches)
        })
      })
  }
}
